import React from 'react'
import { compose, lifecycle, withProps } from 'recompose'
import { connect } from 'react-redux'
import { reduxForm, submit } from 'redux-form/immutable'
import parseSearchQuery from 'sidecar-utils/lib/parseSearchQuery'
import withPageTitle from 'sidecar-utils/lib/enhancers/withPageTitle'

import { fetchAuthedPartner } from 'store/Partner'
import { login, flushAuthError } from 'store/Auth'
import { clearNotificationDomain } from 'store/Notification'

const enhance = compose(
  withPageTitle('Sign in'),
  connect(
    ({ Auth }) => ({
      loginMessage: Auth.get('message'),
      loginError: Auth.get('error'),
      busy: Auth.get('busy'),
    }),
    {
      login,
      submit,
      flushAuthError,
      clearNotificationDomain,
      fetchAuthedPartner,
    },
  ),
  withProps({
    emailRef: React.createRef(),
  }),
  reduxForm({
    form: 'Login',
    onSubmit: async (formData, __, props) => {
      const result = await props.login(formData.toJS())
      if (result.error) return

      const { next } = parseSearchQuery(props.location.search)
      const nextUrl = !!next ? decodeURIComponent(next) : '/dashboard'

      props.fetchAuthedPartner()
      props.history.push(nextUrl)
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.emailRef.current.focus()
    },
    componentWillUnmount() {
      this.props.flushAuthError()
      this.props.clearNotificationDomain('login')
    },
  }),
)

export default enhance



// WEBPACK FOOTER //
// ./src/pages/Login/enhance.js